import React, { useRef } from 'react';
import _, { isUndefined, join } from 'lodash';
import { Form as SemanticForm } from 'semantic-ui-react';
import { FormFieldProp } from '../../../enum/apiResultProp/FormFieldProp';
import StandardButton from '../formButton/button/StandardButton';

export default ({ fieldProps, onValueChange, fileIndex }) => {
    const fileInputRef = useRef(null);

    const allFiles = fieldProps[FormFieldProp.Value];
    let currentFile = null;
    if (allFiles && !isUndefined(allFiles[fileIndex])) {
        currentFile = allFiles[fileIndex];
    }

    const placeholder = fieldProps[FormFieldProp.Placeholder];
    const showLabel = fieldProps[FormFieldProp.ShowLabel];
    const label = fieldProps[FormFieldProp.Label];
    const hasError = fieldProps[FormFieldProp.HasError];
    const showMandatorySign = fieldProps[FormFieldProp.ShowMandatorySign];
    const isReadOnly = fieldProps[FormFieldProp.IsReadOnly];
    const chooseButtonProps = fieldProps[FormFieldProp.ChooseFileButton];
    const cancelButtonProps = fieldProps[FormFieldProp.CancelFileButton];

    const renderHiddenFileField = () => {
        if (currentFile) {
            return null;
        }

        return (
            <input
                type='file'
                multiple={false}
                onChange={async (e) => {
                    const file = e.target.files[0];
                    await onValueChange({ value: file });
                }}
                style={{ display: 'none' }}
                ref={fileInputRef}
                id="actual-btn"
            />
        );
    }

    const openFileSelectionDialog = () => {
        if (!currentFile) {
            fileInputRef.current.click();
        }
    }

    const renderVisualFileField = () => {
        let visualFieldText = placeholder;
        let visualFieldButton = <StandardButton onButtonClick={openFileSelectionDialog} buttonProps={chooseButtonProps} />;
        if (currentFile) {
            visualFieldText = currentFile.name;
            visualFieldButton = <StandardButton onButtonClick={async() => {await onValueChange({ value: undefined })}} buttonProps={cancelButtonProps} />;
        }

        let visualFileFieldProps = {
            disabled: isReadOnly,
            readOnly: true,
            value: visualFieldText,
            actionPosition: 'left',
            action: visualFieldButton,
            error: hasError,
            onClick: openFileSelectionDialog
        };
        if (showLabel) {
            visualFileFieldProps = { ...visualFileFieldProps, ...{ label: label, required: showMandatorySign } };
        }

        return <SemanticForm.Input {...visualFileFieldProps} />;
    }

    const field = (
        <SemanticForm.Field>
            {renderHiddenFileField()}
            {renderVisualFileField()}
        </SemanticForm.Field>
    );

    return field;
}
